import Vue from 'vue'
import './flutterBridge.js'
import '@/i18n/locale'
import { urlParse } from '@/common/utils/util.js'
import { trackEvent } from '@/common/utils/log.js'
import { initGlobalBridge, toggleTitleBar, getStatusBarInfo } from '@/common/utils/bridge.js'
import fastclick from 'fastclick'
import entryRN from './entry-rn.js'
import entryH5 from './entry-h5.js'
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime'
import { preTool } from './pre-switch.js'
import hostConfig from '@/common/config/hosts.js'
import MapView from '@didi/soda-map-view'
import 'viewerjs/dist/viewer.css'
import '@/common/style/main.scss'
import '@/common/style/animation.scss'
// import '@/common/style/icon/iconfont.styl'
import PerformanceTool from '@didi/soda-fe-performance-tool'
import NEED_RECORD_API_LIST from '@/common/config/need-record-api-list.js'
import '@/pages-v2/home/workbench/assets/iconfonts/didi-iconfont.css'
import '@/common/style/crm-icons/crm-icon.css'
import daphne from '@didi/daphne-sdk-javascript'
import AndroidBackPressHandler from '@/common/utils/AndroidBackPressHandler.js'
import setAppStateListener from '@/common/utils/Bridge/setAppStateListener.js'
import setLocationListener from '@/common/utils/Bridge/setLocationListener.js'
// 2025.02.13 增加portal-vue 用于内部弹窗插入到body中或者指定元素中
import PortalVue from 'portal-vue'
Vue.use(PortalVue)
// 2019.11.12 增加isIOSTest标示，为打一个有console的包，便于前线帮忙定位JS报错问题
// if (urlParse(location.href).isIOSTest) {
// import VConsole from 'vconsole'
//   import('vconsole').then(VConsole => {
// new VConsole()
//   })
// }
daphne.init({
  global: true,
  debug: false,
})
window.onerror = function (msg, url, lineNo, columnNo, error) {
  console.warn(arguments)
  trackEvent('sailing_gattarman_x_js_error', {
    stack: (error && error.stack) || null,
    message: msg,
    url,
    line_number: lineNo,
    column_number: columnNo,
  })
}

require('@/common/utils/Observer/index.js')

// Vue.config.errorHandler = function (error) {
//   console.warn(arguments)
//   trackEvent('sailing_gattarman_x_js_error_vue', {
//     name: error.name,
//     stack: error.stack,
//     message: error.message
//   })
// }

PerformanceTool.init({
  NEED_RECORD_API_LIST,
  isNeedRange: true,
})
// // init jsBridge
initGlobalBridge()
fastclick.attach(document.body)
fastclick.prototype.focus = function (targetElement) {
  let length
  if (
    targetElement.selectRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month'
  ) {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.selectRange(length, length)
  } else {
    targetElement.focus()
  }
}
Vue.config.devtools = true
Vue.config.productionTip = false
if (process.env.NODE_ENV === 'production') {
  preTool(hostConfig)
  OfflinePluginRuntime.install()
} else {
  // dev 注销sw
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then(registration => {
      registration &&
        registration.unregister().then(boolean => {
          boolean ? console.log('sw:注销成功') : console.log('sw:注销失败')
        })
    })
  }
}
Vue.use(MapView, {
  type: 'dgmap',
  // ak: 'AIzaSyBWzAgP_42RlLrBaFcTi_J1w_nIQuwGhAI',
  // plugin: ['drawing', 'geometry', 'places']
  // type: 'amap',
  // ak: '5515092ef63deb9b032f460337fba660',
  // plugin: ['AMap.MouseTool', 'AMap.PolyEditor']
})
Vue.prototype.$validate = function (form) {
  return new Promise((resolve, reject) => {
    this.$refs[form].validate(res => {
      if (res) {
        resolve(res)
      } else {
        reject(res)
      }
    })
  })
}
// 判断是否需要从native获取userInfo
window.SODA_RN = urlParse(location.href).isRN

window.addEventListener('pageshow', function () {
  AndroidBackPressHandler.uninit()
  AndroidBackPressHandler.init()
  toggleTitleBar(2)
})

setAppStateListener.init()
setLocationListener.init()

// 隐藏原生标题栏
// TODO: BDAPP改造之后使用新的方案
toggleTitleBar(2)

// console.log('rn', window.SODA_RN)
if (window.SODA_RN) {
  entryRN()
} else {
  entryH5()
}
// 根据版本设置状态栏信息
getStatusBarInfo()
